export default __webpack_public_path__ + "images/16e09062e02fcf0c16001689c96adc8e.png";